// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../procollege/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../procollege/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#procollege_desktop2 .category th,#procollege_desktop2 .category td{height:auto}`, "",{"version":3,"sources":["webpack://./../blocks/psm_desktop2/widgets/staffInfo/widget.vue"],"names":[],"mappings":"AAGE,oEAEE,WAAA","sourcesContent":["\n#procollege_desktop2 {\n\n  .category th,\n  .category td {\n    height: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
